import type { Device } from "./device";
import type { Item } from "./items";
import type { Site } from "./sites";

export enum ScanHistoryType {
  MANUAL = "manual",
  AUTO = "auto",
}

export interface ScanHistory {
  id: number;

  item: Item;

  device: Device;

  site?: Site;

  scan_step?: number;
  /** Status after this event. Null for a manual override that only changed the sub-client. */
  status_label?: string | null;
  /** Sub-client assigned by a manual override; null otherwise (or after the sub-client was deleted). */
  sub_client?: { id: number; name: string } | null;
  /** Name snapshot of that sub-client, kept after deletion. */
  sub_client_name?: string | null;
  location?: string | null;

  gross_weight?: number | null;
  net_weight?: number | null;
  tare_weight?: number | null;
  initial_weight?: number | null;
  gas_added_weight?: number | null;
  refill_success?: boolean;
  refill_error_reason?: string | null;

  latitude: number | null;
  longitude: number | null;

  type: ScanHistoryType;

  createdAt: string; // ISO string
  updatedAt: string; // ISO string
}
